<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input
                           class="form-control mr-sm-2"
                           type="text"
                           placeholder="เลขที่ใบกำกับภาษี"/>
                    <button class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-primary">
                        <icon name="print"></icon>
                        พิมพ์ใบกำกับภาษี
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">
                        <input type="checkbox"/>
                    </th>
                    <th>วัน/เดือน/ปี</th>
                    <th>เลขที่ใบกำกับภาษี</th>
                    <th>เลขที่การตัดจ่าย (CS)</th>
                    <th>ชื่อผู้จำหน่าย</th>
                    <th>จำนวนเงิน</th>
                    <th>พิมพ์</th>
                    <th>ยกเลิก</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in tax_payoff_list">
                    <td>
                        <input type="checkbox"/>
                    </td>
                    <td>{{data.created_at | moment("DD/MM/YYYY")}}</td>
                    <td>{{data.tax_number}}</td>
                    <td>
                        <template v-if="data.rr_payoff">
                            {{data.rr_payoff.no}}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.rr_payoff && data.rr_payoff.vendor">
                            {{data.rr_payoff.vendor.name}}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.rr_payoff">
                            {{data.rr_payoff.total_amount}}
                        </template>
                    </td>
                    <td>
                        <button class="btn btn-primary" disabled>
                            <icon name="print"></icon>
                            พิมพ์
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-danger">
                            <icon name="trash"></icon>
                            ลบ
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--delete-->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <br>
        <!--<pre class="alert-primary">{{tax_payoff_list}}</pre>-->
        <!--<pre class="alert-primary">{{select_all}}</pre>-->
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Multiselect from "vue-multiselect";
    import VuePagination from "../../Pagination";
    import { domain } from "../../../util/Constants";
    export default {
        name: "tax-r-r-payoff-list",
        created(){
            this.$store.dispatch("TaxPayoff/getTaxPayoffList") ;
        },
        components: {
            Multiselect,
            VuePagination
        },
        computed:{
            ...mapState({
                tax_payoff_list : state=>{
                    return state.TaxPayoff.tax_payoff_list
                }
            })
        }
    }
</script>

<style scoped>

</style>